import wx from "weixin-js-sdk"

let init = () => {
    wx.config({
        debug: false,
        appId: window.WXToken.appId,
        timestamp: window.WXToken.timestamp,
        nonceStr: window.WXToken.nonceStr,
        signature: window.WXToken.signature,
        jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
        ]
    });

    wx.ready(function () {
        let shareInfo = {
            title: document.title,
            desc: document.getElementsByName("description")[0].content || document.title || "打开壮观APP看直播",
            imgUrl: document.getElementsByName("shareImage")[0].content || document.shareImage || "https://v.gxnews.com.cn/images/zg/zg_logo.png"
        }
        wx.onMenuShareAppMessage(shareInfo);
        wx.onMenuShareTimeline(shareInfo);
        wx.onMenuShareQQ(shareInfo);
        wx.onMenuShareWeibo(shareInfo);
        wx.onMenuShareQZone(shareInfo);
    });
}


export default {
    init
}